import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import UISection from 'UIComponents/section/UISection';
const DefaultHeading = styled.span.attrs({
  className: 'is--heading-7'
}).withConfig({
  displayName: "ReviewSection__DefaultHeading",
  componentId: "sc-14xf579-0"
})(["margin-bottom:4px;"]);
export default function ReviewSection({
  HeadingComponent = DefaultHeading,
  title,
  children
}) {
  return /*#__PURE__*/_jsxs(UISection, {
    children: [title && /*#__PURE__*/_jsx(HeadingComponent, {
      children: title
    }), children]
  });
}